// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.urDvE3ALv4mSpMsAB6xQ {
  /* Shared styling for the bellLink boost theme (base + VIP) */
  --jp-boost-label-top: 8px;
  --jp-boost-label-left: 4px;
  --jp-boost-label-width: 40px;
  --jp-level-value-align: end;
  --jp-level-value-padding-right: 46px;
  --jp-currency-position: relative;
  --jp-currency-margin-left: 5px;
  --jp-currency-line-height: 0.9;
  --jp-value-font-weight: 500;
  --jp-grand-currency-font-size: 10px;
  --jp-major-currency-font-size: 10px;
  --jp-minor-currency-font-size: 9px;
  --jp-mini-currency-font-size: 9px;
  --jp-grand-font-size: 37px;
  --jp-major-font-size: 35px;
  --jp-minor-font-size: 33px;
  --jp-minor-font-size: 30px;
  --jp-grand-width: 254px;
  --jp-major-width: 224px;
  --jp-minor-width: 190px;
  --jp-mini-width: 154px;
  --jp-grand-height: 60px;
  --jp-major-height: 59px;
  --jp-minor-height: 30px;
  --jp-mini-height: 30px;
  --jp-boost-grand-currency-top: 21px;
  --jp-boost-major-currency-top: 21px;
  --jp-boost-minor-currency-top: 1px;
  --jp-boost-mini-currency-top: 1px;
  --jp-boost-level-value-top: 10px;
  grid-auto-flow: column;
  /* Panel icon styling */
}
.urDvE3ALv4mSpMsAB6xQ div[data-type='levelsContainer'] {
  position: relative;
  grid-template-columns: 1fr;
  row-gap: 5px;
  margin-left: -149px;
  justify-items: end;
  bottom: 8px;
}
.urDvE3ALv4mSpMsAB6xQ div[data-type='panelIcon'] {
  width: 221px;
  height: 226px;
  position: relative;
  top: -2px;
}
.urDvE3ALv4mSpMsAB6xQ div[data-type='panelIcon'] picture {
  width: inherit;
  height: inherit;
}
.urDvE3ALv4mSpMsAB6xQ div[data-type='panelIcon'] picture img {
  width: inherit;
  height: inherit;
  object-fit: cover;
}
.urDvE3ALv4mSpMsAB6xQ div[data-level='grand'] [data-boost-value] {
  bottom: 77%;
  right: 30%;
}
.urDvE3ALv4mSpMsAB6xQ div[data-level='major'] [data-boost-value] {
  bottom: 76%;
  right: 33%;
}
.urDvE3ALv4mSpMsAB6xQ div[data-level='minor'] {
  top: 2px;
}
.urDvE3ALv4mSpMsAB6xQ div[data-level='minor'] > span {
  top: 1px;
}
.urDvE3ALv4mSpMsAB6xQ div[data-level='mini'] {
  font-size: 30px;
  top: 4px;
}
.urDvE3ALv4mSpMsAB6xQ div[data-level='mini'] > span {
  top: 1px;
}
@media (max-width: 1025px) {
  .urDvE3ALv4mSpMsAB6xQ {
    --jp-boost-label-top: 5px;
    /* Level Font Size */
    --jp-grand-font-size: 34px;
    --jp-major-font-size: 32px;
    --jp-minor-font-size: 30px;
    --jp-mini-font-size: 28px;
    --jp-grand-width: 234px;
    --jp-major-width: 203px;
    --jp-minor-width: 177px;
    --jp-mini-width: 143px;
    --jp-grand-height: 52px;
    --jp-major-height: 50px;
    --jp-minor-height: 28px;
    --jp-mini-height: 26px;
    --jp-grand-currency-font-size: 9px;
    --jp-major-currency-font-size: 9px;
    --jp-minor-currency-font-size: 8px;
    --jp-mini-currency-font-size: 8px;
  }
  .urDvE3ALv4mSpMsAB6xQ div[data-type='levelsContainer'] {
    margin-left: -100px;
    row-gap: 3px;
  }
  .urDvE3ALv4mSpMsAB6xQ div[data-type='panelIcon'] {
    width: auto;
    height: 200px;
    position: relative;
  }
  .urDvE3ALv4mSpMsAB6xQ div[data-type='panelIcon'] picture img {
    object-fit: contain;
  }
  .urDvE3ALv4mSpMsAB6xQ div[data-level='major'] [data-boost-value] {
    bottom: 78%;
  }
  .urDvE3ALv4mSpMsAB6xQ div[data-level='mini'] {
    font-size: 28px;
    top: 4px;
  }
  .urDvE3ALv4mSpMsAB6xQ div[data-level='minor'] {
    top: 2px;
  }
}
@media (orientation: portrait) {
  .urDvE3ALv4mSpMsAB6xQ {
    margin-top: 1px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/jackpots/components/variants/base/BellLinkBoost.base.module.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;EAChC,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;EACjC,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,mCAAmC;EACnC,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,eAAe;EACf,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE;IACE,yBAAyB;IACzB,oBAAoB;IACpB,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;IAClC,iCAAiC;EACnC;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,QAAQ;EACV;EACA;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".bellLinkBoostTheme {\n  /* Shared styling for the bellLink boost theme (base + VIP) */\n  --jp-boost-label-top: 8px;\n  --jp-boost-label-left: 4px;\n  --jp-boost-label-width: 40px;\n  --jp-level-value-align: end;\n  --jp-level-value-padding-right: 46px;\n  --jp-currency-position: relative;\n  --jp-currency-margin-left: 5px;\n  --jp-currency-line-height: 0.9;\n  --jp-value-font-weight: 500;\n  --jp-grand-currency-font-size: 10px;\n  --jp-major-currency-font-size: 10px;\n  --jp-minor-currency-font-size: 9px;\n  --jp-mini-currency-font-size: 9px;\n  --jp-grand-font-size: 37px;\n  --jp-major-font-size: 35px;\n  --jp-minor-font-size: 33px;\n  --jp-minor-font-size: 30px;\n  --jp-grand-width: 254px;\n  --jp-major-width: 224px;\n  --jp-minor-width: 190px;\n  --jp-mini-width: 154px;\n  --jp-grand-height: 60px;\n  --jp-major-height: 59px;\n  --jp-minor-height: 30px;\n  --jp-mini-height: 30px;\n  --jp-boost-grand-currency-top: 21px;\n  --jp-boost-major-currency-top: 21px;\n  --jp-boost-minor-currency-top: 1px;\n  --jp-boost-mini-currency-top: 1px;\n  --jp-boost-level-value-top: 10px;\n  grid-auto-flow: column;\n  /* Panel icon styling */\n}\n.bellLinkBoostTheme div[data-type='levelsContainer'] {\n  position: relative;\n  grid-template-columns: 1fr;\n  row-gap: 5px;\n  margin-left: -149px;\n  justify-items: end;\n  bottom: 8px;\n}\n.bellLinkBoostTheme div[data-type='panelIcon'] {\n  width: 221px;\n  height: 226px;\n  position: relative;\n  top: -2px;\n}\n.bellLinkBoostTheme div[data-type='panelIcon'] picture {\n  width: inherit;\n  height: inherit;\n}\n.bellLinkBoostTheme div[data-type='panelIcon'] picture img {\n  width: inherit;\n  height: inherit;\n  object-fit: cover;\n}\n.bellLinkBoostTheme div[data-level='grand'] [data-boost-value] {\n  bottom: 77%;\n  right: 30%;\n}\n.bellLinkBoostTheme div[data-level='major'] [data-boost-value] {\n  bottom: 76%;\n  right: 33%;\n}\n.bellLinkBoostTheme div[data-level='minor'] {\n  top: 2px;\n}\n.bellLinkBoostTheme div[data-level='minor'] > span {\n  top: 1px;\n}\n.bellLinkBoostTheme div[data-level='mini'] {\n  font-size: 30px;\n  top: 4px;\n}\n.bellLinkBoostTheme div[data-level='mini'] > span {\n  top: 1px;\n}\n@media (max-width: 1025px) {\n  .bellLinkBoostTheme {\n    --jp-boost-label-top: 5px;\n    /* Level Font Size */\n    --jp-grand-font-size: 34px;\n    --jp-major-font-size: 32px;\n    --jp-minor-font-size: 30px;\n    --jp-mini-font-size: 28px;\n    --jp-grand-width: 234px;\n    --jp-major-width: 203px;\n    --jp-minor-width: 177px;\n    --jp-mini-width: 143px;\n    --jp-grand-height: 52px;\n    --jp-major-height: 50px;\n    --jp-minor-height: 28px;\n    --jp-mini-height: 26px;\n    --jp-grand-currency-font-size: 9px;\n    --jp-major-currency-font-size: 9px;\n    --jp-minor-currency-font-size: 8px;\n    --jp-mini-currency-font-size: 8px;\n  }\n  .bellLinkBoostTheme div[data-type='levelsContainer'] {\n    margin-left: -100px;\n    row-gap: 3px;\n  }\n  .bellLinkBoostTheme div[data-type='panelIcon'] {\n    width: auto;\n    height: 200px;\n    position: relative;\n  }\n  .bellLinkBoostTheme div[data-type='panelIcon'] picture img {\n    object-fit: contain;\n  }\n  .bellLinkBoostTheme div[data-level='major'] [data-boost-value] {\n    bottom: 78%;\n  }\n  .bellLinkBoostTheme div[data-level='mini'] {\n    font-size: 28px;\n    top: 4px;\n  }\n  .bellLinkBoostTheme div[data-level='minor'] {\n    top: 2px;\n  }\n}\n@media (orientation: portrait) {\n  .bellLinkBoostTheme {\n    margin-top: 1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bellLinkBoostTheme": `urDvE3ALv4mSpMsAB6xQ`
};
export default ___CSS_LOADER_EXPORT___;
